var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-avatar',{attrs:{"src":_vm.$keycloak.tokenParsed.picture,"badge":"","badge-variant":_vm.badgeVariant,"badge-offset":"-3px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }